"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Parts_1 = require("./_Parts");
var _Initiator_1 = require("./_Initiator");
var _Owner_1 = require("./_Owner");
exports.ListPartsOutput = {
    type: "structure",
    required: [],
    members: {
        AbortDate: {
            shape: {
                type: "timestamp"
            },
            location: "header",
            locationName: "x-amz-abort-date"
        },
        AbortRuleId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-abort-rule-id"
        },
        Bucket: {
            shape: {
                type: "string"
            }
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        UploadId: {
            shape: {
                type: "string"
            }
        },
        PartNumberMarker: {
            shape: {
                type: "integer"
            }
        },
        NextPartNumberMarker: {
            shape: {
                type: "integer"
            }
        },
        MaxParts: {
            shape: {
                type: "integer"
            }
        },
        IsTruncated: {
            shape: {
                type: "boolean"
            }
        },
        Parts: {
            shape: _Parts_1._Parts,
            locationName: "Part"
        },
        Initiator: {
            shape: _Initiator_1._Initiator
        },
        Owner: {
            shape: _Owner_1._Owner
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=ListPartsOutput.js.map